module.exports = __webpack_public_path__ + "static/media/level2.57250282.jpg";